import {Crawler} from "../../utilities/crawler"
import {ApiObjectKindType} from "@radivision/graphql"


export const crawlFetch = (url: string) => {
  return Crawler.fetch(url, ApiObjectKindType.ARTICLE_STORY)
};
